export default "__VITE_ASSET__BzxY7KXL__"